import { createContext } from 'react';

/**
 * Question de détail posée depuis un visuel (lien « Détails » d'une tuile KPI, clic ou
 * Entrée sur une barre, un point ou une part d'un graphique) : fournie par la
 * conversation, désactivée pendant une réponse en cours. Absente dans le panneau
 * d'artefacts et le tableau de bord : ni lien ni exploration.
 */
export const VisualAskContext = createContext({ ask: null, busy: false });
